import React, { useContext } from "react";
import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";
import { AppContext } from "../App";

const services = [
  {
    id: 1,
    title: "Tax Consultancy",
    description:
      "End-to-end tax compliance, advisory, and dispute resolution services ensuring regulatory adherence while optimizing your tax position.",
    image: banner1,
    features: [
      "Tax Compliance (VAT, PAYE, WHT, CIT)",
      "Disputes Resolution & Appeals",
      "Transfer Pricing Advisory",
    ],
    subItem: "taxation",
  },
  {
    id: 2,
    title: "Management Accounting",
    description:
      "Strategic financial insight to connect business strategy with execution and performance.",
    image: banner2,
    features: [
      "Financial Strategy Review",
      "Risk & Control Frameworks",
      "KPI & Scorecard Design",
    ],
    subItem: "management-accounting",
  },
  {
    id: 3,
    title: "Project Management",
    description:
      "End-to-end project oversight ensuring timely delivery, cost control, and measurable outcomes.",
    image: banner3,
    features: [
      "Planning & Execution",
      "Budget Tracking",
      "Donor Compliance",
    ],
    subItem: "project-management",
  },
  {
    id: 4,
    title: "Internal Audit",
    description:
      "Independent assurance to strengthen governance, controls, and risk visibility.",
    image: banner4,
    features: [
      "Internal Controls Review",
      "Fraud Risk Assessment",
      "Compliance Audits",
    ],
    subItem: "internal-audit",
  },
];

const ServicesBanner1 = () => {
  const appContext = useContext(AppContext);

  return (
    <section className="svc-section py-5">
      <div className="container">
        {/* HEADER */}
        <div className="svc-header text-center">
          <h2 className="text-primary font-bold">Core Professional Services</h2>
          <p className="svc-subtitle">
            High-impact advisory services designed to strengthen your business
            performance and decision-making.
          </p>
        </div>

        {/* GRID */}
        <div className="row g-4">
          {services.map((service) => (
            <div key={service.id} className="col-md-6">
              <div
                className="svc-card"
                onClick={() =>
                  appContext.navTo({
                    item: "services",
                    subItem: service.subItem,
                  })
                }
              >
                {/* IMAGE */}
                <div className="svc-card__imageWrap">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="svc-card__image"
                  />
                </div>

                {/* CONTENT */}
                <div className="svc-card__body">
                  <h3 className="svc-card__title">{service.title}</h3>
                  <p className="svc-card__desc">{service.description}</p>

                  <ul className="svc-card__list">
                    {service.features.map((f, i) => (
                      <li key={i}>
                        <span>✓</span> {f}
                      </li>
                    ))}
                  </ul>

                  <button className="svc-card__btn">
                    Explore <span>→</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="svc-cta text-center mt-5">
          <p>Ready to elevate your business?</p>
          <button
            className="btn btn-primary btn-rounded btn-lg"
            onClick={() => appContext.navTo({ item: "contact_us" })}
          >
            Schedule Consultation
          </button>
        </div>
      </div>

      <style jsx>{`
        .svc-section {
          background: linear-gradient(135deg, #f1f5f9, #e2e8f0);
        }

        .svc-header {
          max-width: 700px;
          margin: 0 auto 3rem;
        }

        .svc-subtitle {
          color: #475569;
          margin-top: 0.5rem;
        }

        /* CARD */
        .svc-card {
          background: rgba(255, 255, 255, 0.7);
          backdrop-filter: blur(10px);
          border-radius: 18px;
          overflow: hidden;
          cursor: pointer;
          transition: all 0.3s ease;
          border: 1px solid rgba(255, 255, 255, 0.4);
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .svc-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
        }

        .svc-card__imageWrap {
          height: 220px;
          overflow: hidden;
        }

        .svc-card__image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .svc-card:hover .svc-card__image {
          transform: scale(1.08);
        }

        .svc-card__body {
          padding: 1.5rem;
          display: flex;
          flex-direction: column;
          flex-grow: 1;
        }

        .svc-card__title {
          font-size: 1.3rem;
          font-weight: 600;
          color: #1e293b;
        }

        .svc-card__desc {
          font-size: 0.95rem;
          color: #475569;
          margin: 0.7rem 0 1rem;
        }

        .svc-card__list {
          list-style: none;
          padding: 0;
          margin-bottom: 1.2rem;
        }

        .svc-card__list li {
          font-size: 0.9rem;
          color: #334155;
          margin-bottom: 0.3rem;
        }

        .svc-card__list span {
          color: #222736;
          font-weight: bold;
        }

        .svc-card__btn {
          margin-top: auto;
          background: linear-gradient(135deg, #2563eb, #1d4ed8);
          color: #fff;
          border: none;
          padding: 0.7rem 1.4rem;
          border-radius: 8px;
          font-size: 0.9rem;
          cursor: pointer;
          transition: 0.2s;
        }

        .svc-card__btn:hover {
          transform: translateX(4px);
        }

        /* CTA */
        .svc-cta p {
          color: #475569;
          margin-bottom: 1rem;
        }

        .svc-cta__btn {
          background: linear-gradient(135deg, #059669, #10b981);
          color: #fff;
          border: none;
          padding: 0.9rem 2rem;
          border-radius: 10px;
          font-weight: 600;
          cursor: pointer;
        }

        .svc-cta__btn:hover {
          transform: translateY(-2px);
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .svc-card__imageWrap {
            height: 180px;
          }
        }
      `}</style>
    </section>
  );
};

export default ServicesBanner1;